import { useTranslation } from "react-i18next";
import { getPageContents } from "../../../../actions/admin/cmspage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";
import { DownloadLargeIcon } from "../../../../components/icons";


export const YokohamaOsanbashiPier = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);

  return (
    <div>
      <div className="tw:flex tw:flex-col tw:lg:flex-row tw:overflow-hidden tw:border tw:border-[#DADADA] tw:rounded-md tw:relative tw:w-full tw:p-6">

        <div className="tw:flex-1">
          <img
            src={t("MapPage.YokohamaOsanbashiPier.YokohamaOsanbashiPierImageUrl")}
            className="tw:w-full tw:h-auto tw:object-contain"
            alt="Tokyo Station"
          />
        </div>
        <div className="tw:min-w-[200px]">
          <a
            href={t("MapPage.YokohamaOsanbashiPier.YokohamaOsanbashiPierImageUrl")}
            download
            target="_blank"
            className={cn(
              "tw:flex tw:items-center tw:justify-center tw:gap-3 tw:px-[18px] tw:h-[44px] tw:font-bold tw:border tw:border-[#C9C9C9D8] tw:rounded-md tw:cursor-pointer tw:!no-underline tw:!text-[#282828]",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <div className="tw:w-3"><DownloadLargeIcon color="#282828" size={13} /></div>
            <div>
              {t("MapPage.Download")}
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};